import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const mainLinks = [
    { name: '首页', path: '/', icon: 'ri-home-line' },
    { name: '电影', path: '/category/all', icon: 'ri-movie-line' },
    { name: '电视剧', path: '/category/tvseries', icon: 'ri-tv-line' },
    { name: '动漫', path: '/category/animation', icon: 'ri-mickey-line' },
    { name: '关于我们', path: '/about', icon: 'ri-information-line' },
  ];

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
            : 'bg-transparent'
        }`}
      >
        <div className="px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-lg text-white"></i>
              </div>
              <span className="text-xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                7777影院
              </span>
            </Link>

            <div className="hidden md:flex items-center gap-1">
              {mainLinks.map((link) => {
                const isActive = link.path === '/'
                  ? location.pathname === '/'
                  : location.pathname.startsWith(link.path);
                return (
                  <Link
                    key={link.path}
                    to={link.path}
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                      isActive
                        ? 'bg-primary-500/15 text-primary-500'
                        : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100'
                    }`}
                  >
                    {link.name}
                  </Link>
                );
              })}
            </div>

            <div className="hidden md:flex items-center gap-3">
              <Link
                to="/category/all"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 hover:bg-background-200 transition-colors cursor-pointer"
              >
                <i className="ri-search-line text-foreground-600 text-lg"></i>
              </Link>
              <Link
                to="/category/all"
                className="px-5 py-2 bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 rounded-md text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                立即观看
              </Link>
            </div>

            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 cursor-pointer"
              aria-label="菜单"
            >
              <i className={`text-foreground-600 text-lg ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </nav>

      {mobileOpen && (
        <div className="fixed inset-0 z-40 md:hidden">
          <div className="absolute inset-0 bg-black/60" onClick={() => setMobileOpen(false)}></div>
          <div className="absolute top-16 left-0 right-0 bg-background-50 border-b border-background-200/60 p-4">
            <div className="flex flex-col gap-1">
              {mainLinks.map((link) => {
                const isActive = link.path === '/'
                  ? location.pathname === '/'
                  : location.pathname.startsWith(link.path);
                return (
                  <Link
                    key={link.path}
                    to={link.path}
                    className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all cursor-pointer ${
                      isActive
                        ? 'bg-primary-500/15 text-primary-500'
                        : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100'
                    }`}
                  >
                    <i className={`${link.icon} text-lg`}></i>
                    {link.name}
                  </Link>
                );
              })}
              <Link
                to="/category/all"
                className="flex items-center gap-3 px-4 py-3 mt-3 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-semibold cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观看
              </Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
}